// extracted by mini-css-extract-plugin
export default {"mainContainer":"section-module___mainContainer___fec3255f","header":"section-module___header___c7971783"};